import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ExportsViewProvider from '../../../components/AdvancedExportModal';

import PageHeader from '../components/PageHeader';
import WorldwideTotals from '../components/WorldwideTotals';
import AppsTable from '../components/AppsTable';
import Monetization from '../components/Monetization';
import DownloadsRevenue from '../components/DownloadsRevenue';
import InstalledSdks from '../components/InstalledSdks';
import CompanyContacts from '../components/CompanyContacts';

import { fetchPageData } from '../actions/page-data-actions';
import { initParams } from '../configs';

import { isUnified } from '../../../utils/helpers';

const { store, permissions, maxDate, maxPeriod } = initParams;

const exportInitParams = {
  maxDate,
  maxPeriod: parseInt(maxPeriod, 10),
  permissions,
  pageName: 'publisher',
};

const PageContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPageData());
  }, []);

  return (
    <ExportsViewProvider
      initParams={exportInitParams}
      reportParams={{ store, permissions, maxDate, maxPeriod, pageName: 'publisher' }}
    >
      <div className="publisher_page container pos-rel">
        <PageHeader />
        <WorldwideTotals />
        <AppsTable />
        {isUnified(store) && !permissions.isFlexUser ? (
          <>
            <Monetization />
            <DownloadsRevenue />
          </>
        ) : (
          <div className="row b-t">
            <div className="col-lg-4 col-xl-3 m-b">
              <div className="card m-b-0 h-100 d-flex flex-items-xxs-column">
                <Monetization />
              </div>
            </div>
            <div className="col-lg-8 col-xl-9 m-b">
              <div className="b-l pos-abs hidden-md-down publisher_page__col_divider" />
              <div className="b-b hidden-lg-up" />
              <DownloadsRevenue />
            </div>
          </div>
        )}
        {permissions.allowTotals && <InstalledSdks />}
        <CompanyContacts />
      </div>
    </ExportsViewProvider>
  );
};

export default PageContainer;
